import {
  AppointmentRescheduleStatus,
  DomainColors,
  FrequencyTypes,
} from "@/domain/contracts";
import moment from "moment";
import {
  AppointmentStatus,
  AppointmentStatuses,
} from "./../../domain/contracts/AppointmentStatuses";

export function fixFrequency(
  frequency: string,
  interval: number,
): FrequencyTypes {
  return frequency === FrequencyTypes.weekly && interval === 2
    ? FrequencyTypes.fortnightly
    : (frequency as FrequencyTypes);
}

export function getFrequencyDateText(
  frequency: string,
  interval: number,
  date: string,
  capitalize = false,
): string {
  const weekDay = moment(date).day();
  const d = moment(date).format("dddd");
  const splittedDay = d.split("-");
  const day =
    splittedDay.length > 1
      ? `${splittedDay[0]}s-${splittedDay[1]}s`
      : `${splittedDay[0]}s`;
  const acronym = [6, 0].includes(weekDay) ? "aos" : "nas";

  switch (frequency) {
    case FrequencyTypes.daily:
      return "";
    case FrequencyTypes.weekly:
      if (interval > 1) {
        return `${
          capitalize ? "A" : "a"
        } cada duas semanas ${acronym} ${day} às ${moment(date).format(
          "HH[h]",
        )}.`;
      }
      return `${
        capitalize ? "T" : "t"
      }odas as semanas ${acronym} ${day} às ${moment(date).format("HH[h]")}.`;
    case FrequencyTypes.monthly:
      return `${capitalize ? "T" : "t"}odos os meses nos dias ${moment(
        date,
      ).format("DD")} às ${moment(date).format("HH[h]")}.`;
    case FrequencyTypes.fortnightly:
      return `${
        capitalize ? "A" : "a"
      } cada duas semanas ${acronym} ${day} às ${moment(date).format(
        "HH[h]",
      )}.`;
    default:
      return "";
  }
}

export function getAppointmentStatusLabel(item: {
  status: string;
  rescheduleRequest?: { status: string };
}): string {
  if (item?.rescheduleRequest?.status === AppointmentRescheduleStatus.pending) {
    return "Reagendamento Pendente";
  }
  switch (item?.status) {
    case "aguardando":
      return "Aguardando confirmação";
    case "agendado":
      return "Confirmado";
    case "concluido":
      return "Sessão finalizada";
    case "recusado":
    case "cancelado":
      return "Sessão cancelada";
    case "em andamento":
      return "Sessão iniciada";
    default:
      return "";
  }
}

export function getAppointmentStatusColor(item: {
  status: string;
  rescheduleRequest?: { status: string };
}): string {
  if (item?.rescheduleRequest?.status === AppointmentRescheduleStatus.pending) {
    return DomainColors.secondary;
  }
  switch (item?.status) {
    case "aguardando":
      return DomainColors.warning;
    case "agendado":
      return DomainColors.success;
    case "concluido":
    case "em andamento":
      return DomainColors.primary;
    case "recusado":
    case "cancelado":
      return DomainColors.danger;
    default:
      return "";
  }
}

export const getFormattedAppointmentStatus = (
  statusName: AppointmentStatus,
  breakLine = false,
) => {
  switch (statusName) {
    case AppointmentStatuses.aguardando:
      return {
        name: breakLine ? "Aguardando\nconfirmação" : "Aguardando confirmação",
        color: DomainColors.warning,
        icon: "clock",
      };
    case AppointmentStatuses.agendado:
      return {
        name: "Confirmado pelo psi",
        color: DomainColors.success,
        icon: "check-circle",
      };
    case AppointmentStatuses.concluido:
      return {
        name: "Finalizada",
        color: DomainColors.primary50,
      };
    case AppointmentStatuses.cancelado:
    case AppointmentStatuses.recusado:
      return {
        name: "Cancelado",
        color: DomainColors.primary50,
      };
    case AppointmentStatuses["em andamento"]:
      return {
        name: "Em andamento",
        color: DomainColors.info50,
      };
    default:
      return {
        name: "Sem status",
        color: "primary",
      };
  }
};
